export type Leave = {
  totalLvDays: unknown;
  reason: string;
  cellDt?: string | number;
  dayType: string;
  approved?: boolean;
  createdBy?: string;
  createdTime?: string;
  empIdNo?: string;
  empName?: string;
  empUuid?: string;
  fromDayType?: string;
  fromDt?: string;
  lastModBy?: string;
  lastModTime?: string;
  lvDays?: number;
  lvRecUuid?: string;
  lvTypeCode?: string;
  lvTypeColor?: string;
  lvTypeName?: string;
  lvTypeUuid?: string;
  remarks?: string;
  status?: string;
  toDayType?: string;
  toDt?: string;
};

export class LeaveRecsQuery {
  empId?: string;
  filter?: string = '';
  pageNumber?: number = 0;
  fromDt?: string = '';
  toDt?: string = '';
  pageSize?: number = 25;
  sortOrder?: string = 'desc';
  status?: string = '';
  lvTypeUuid?: string[] = [];
  sortField?: string = 'lv.fromDt';
  empUuid?: any;
}
